export const ANTD_COLS = 24;
